import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Workspace from 'src/entities/workspace';
import { getWorkspace } from 'src/selectors/workspaces';
import { fetchWorkspaceSettingsInformation } from 'src/actions/workspaces';

const useWorkspaceInformation = ( workspaceID: number ): Workspace => {
	const dispatch = useDispatch();

	// @ts-expect-error - TODO: fix this
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const workspace: Workspace = useSelector( ( state: any ) => getWorkspace( state, { workspaceID } ) );

	useEffect( () => {
		if ( workspace ) {
			dispatch( fetchWorkspaceSettingsInformation( workspace ) );
		}
	}, [ workspace.id ] );

	return workspace;
};

export default useWorkspaceInformation;
